import styled from '@emotion/styled';
import { InputWithIcon } from 'components/Form';
import { themeGet } from '@styled-system/theme-get';
import { InputProps } from './types';

export const CheckInInput = styled(InputWithIcon)<InputProps>`
  border-radius: 4px 0 0 4px;
  border-right: none;
  cursor: pointer;
  border-color: ${(props) => themeGet(props.focused ? 'colors.brand.secondary' : 'colors.greys.alto')(props)};

  &:focus {
    border-color: ${(props) => themeGet(props.focused ? 'colors.brand.secondary' : 'colors.greys.alto')(props)};
  }
`;
